import watabou from "assets/Wata.webp";
import twoMinutes from "assets/2mtt.jpg";
import czepeku from "assets/Czepekuy.jpg";
import dndmaps from "assets/D&D maps.jpg";
import battlemaps from "assets/Battlemps.png";

const mapas = [
  {
    titulo: "Watabou",
    imagem: watabou,
    link: "https://watabou.itch.io/",
  },
  {
    titulo: "Czepeku",
    imagem: czepeku,
    link: "https://www.czepeku.com/maps",
  },
  {
    titulo: "2 Minutes Tabletop",
    imagem: twoMinutes,
    link: "https://2minutetabletop.com/product-category/free/",
  },
  {
    titulo: "D&D Maps",
    imagem: dndmaps,
    link: "https://www.reddit.com/r/dndmaps/",
    icone: "Reddit", 
  },
  {
    titulo: "Battle Maps",
    imagem: battlemaps,
    link: "https://www.reddit.com/r/battlemaps/",
    icone: "Reddit", 
  },
  // Adicione mais mapas conforme necessário
];

export default mapas;
